import { TeamRepository } from '../repositories';

export class RemoveTeamMemberUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(teamId: string, captainId: string, memberUserId: string): Promise<void> {
    if (captainId === memberUserId) {
      throw new Error('Team captain cannot remove themselves. Delete the team instead.');
    }
    await this.teamRepository.removeMember(teamId, memberUserId);
  }
}
